// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App'
import router from './router'
import messages from './messages.js'
import Questionnaire from './Questionnaire/index.js'

Vue.config.productionTip = false
Vue.use(VueI18n)
Vue.use(Questionnaire)


router.beforeEach((to, from, next) => {
  window.scroll({
    top: 0, 
    left: 0, 
    behavior: 'smooth' 
  })
  next()
})

const i18n = new VueI18n({
  locale: 'es',
  fallbackLocale: 'es',
  messages
})

const vue = new Vue({
  el: '#app',
  router,
  i18n,
  template: '<App/>',
  components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js